import "./Initializing.scss";

import * as React from "react";

import { ErrorPageContainer } from "../ErrorPage/ErrorPageContainer";
import UpdatePoller from "../UpdatePoller/UpdatePoller";

import type { RouteComponentProps } from "utils/withRouter";
import type { ErrorDetails, LookupState, UI } from "../../models";

interface InitializingProps extends RouteComponentProps {
  children?: React.ReactNode;
  lookups: LookupState;
  ui: UI;
  initialize: () => void;
  getAvailableFeatures: () => void;
  updateFacilities: () => void;
  getUserPreferences: () => void;
  skipInit?: boolean;
}

export class Initializing extends React.PureComponent<InitializingProps> {
  constructor(props: InitializingProps) {
    super(props);
    this.onRetryClick = this.onRetryClick.bind(this);
  }

  componentDidMount() {
    if (!this.props.ui.initializing && !this.props.ui.initialized) {
      this.props.initialize();
      this.props.getAvailableFeatures();
    }
  }

  render() {
    if (this.props.skipInit) {
      return <div className="initializing-wrapper full-height">{this.props.children}</div>;
    }

    // negate not instant logout redirection visual effects
    if (this.props.location.hash && this.props.location.hash.includes("logouted")) {
      return <div className="initializing-wrapper full-height" />;
    }

    let content: React.ReactNode = (
      <p className="initializing-status">
        <span className="k-icon k-loading-image" />
      </p>
    );
    // FIXME: loading codeBooks only affects CCA, how to deal with this container more generally?
    if (!this.loadingIsActive()) {
      // Determine token status
      // if (true) {
      if (this.props.ui.initializingError) {
        const err: ErrorDetails = {
          error: this.props.ui.initializingErrorDetail,
          name: this.props.ui.initializingErrorReason,
        };
        content = <ErrorPageContainer customError={err} onTryAgainClick={this.onRetryClick} />;
      } else {
        content = this.props.children;
      }
      // Determine lookup status
      if (this.props.lookups.error) {
        const err: ErrorDetails = {
          error: this.props.lookups.errorDetail,
          name: "LookupError",
        };
        content = <ErrorPageContainer customError={err} onTryAgainClick={this.onRetryClick} />;
      }
    }
    return (
      <div className="initializing-wrapper full-height">
        {content}
        <UpdatePoller updateFacilities={this.props.updateFacilities} />
      </div>
    );
  }

  private loadingIsActive = () => this.props.ui.initializing;

  private onRetryClick() {
    if (this.props.ui.initializingError) {
      this.props.initialize();
    }
  }
}
